export { default, TabID, resolvePreloadTab } from "./ContractPeriodTabs";
export type { ContractPeriodTabsProps } from "./ContractPeriodTabs";
